import type { AssessmentState } from "@/contexts/AssessmentContext";

const BASE = "/api/v1/assessment";

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    ...init,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    throw new Error((err as { detail?: string }).detail ?? res.statusText);
  }
  if (res.status === 204) return undefined as T;
  return res.json();
}

export interface AssessmentUpsertPayload {
  responses: AssessmentState["responses"];
  is_complete: boolean;
}

interface ApiAssessmentResponse {
  responses: AssessmentState["responses"];
  is_complete: boolean;
  last_completed_at: string | null;
}

export const assessmentService = {
  get: (): Promise<AssessmentState> =>
    request<ApiAssessmentResponse>(BASE).then((data) => ({
      responses: data.responses ?? {},
      isComplete: data.is_complete ?? false,
      lastCompletedAt: data.last_completed_at ?? null,
    })),

  upsert: (payload: AssessmentUpsertPayload): Promise<AssessmentState> =>
    request<ApiAssessmentResponse>(BASE, {
      method: "PUT",
      body: JSON.stringify(payload),
    }).then((data) => ({
      responses: data.responses ?? {},
      isComplete: data.is_complete ?? false,
      lastCompletedAt: data.last_completed_at ?? null,
    })),

  clear: (): Promise<void> =>
    request<void>(BASE, { method: "DELETE" }),
};
